import { GPIcon, TelehealthIcon } from '../TopNavigationBar.styles';
import { SpecialtyContainer } from './SpecialtyOption.styles';

interface Props {
  url?: string;
  Icon?: typeof TelehealthIcon | typeof GPIcon;
  text: string;
  onClick: () => void;
  className?: string;
  analyticsId: string;
}

export const SpecialtyOption = ({ url, Icon, text, onClick, className, analyticsId }: Props) => (
  <>
    {url ? (
      <SpecialtyContainer as="a" href={url} className={className} data-link-id={analyticsId}>
        {Icon && <Icon />}
        {text}
      </SpecialtyContainer>
    ) : (
      <SpecialtyContainer onClick={onClick} className={className} data-link-id={analyticsId}>
        {Icon && <Icon />}
        {text}
      </SpecialtyContainer>
    )}
  </>
);
